import React, { Component, Fragment } from 'react';
import { isEqual } from 'Utils/';
import Input from 'Components/Input';
import { Status } from 'Components/Status';
import Timer from 'Components/Timer';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import { CHALLENGE_PRICE_SENT } from 'Constants/commonConstants';
import { formatToINR } from 'Utils/transform';
import { ReactComponent as AcceptIcon } from 'Icons/checked.svg';
import { ReactComponent as RejectIcon } from 'Icons/reject.svg';
import { ReactComponent as SaveIcon } from 'Icons/save.svg';
import { ReactComponent as SEOIcon } from 'Icons/seo.svg';
import PostBidPopup from 'Components/PostBidPopup/index';
import OutsideClickHandler from 'react-outside-click-handler';

export default class ZoneList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            zoneList: props.isAdditionalZone && [JSON.parse(JSON.stringify(this.props.zoneList))] || JSON.parse(JSON.stringify(this.props.zoneList))
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(!this.props.isAdditionalZone && nextProps.zoneList && nextProps.zoneList.length && !isEqual(nextProps.zoneList, this.props.zoneList)) {
            this.setState({
                zoneList: JSON.parse(JSON.stringify(nextProps.zoneList))
            })
        }
        if(this.props.isAdditionalZone && nextProps.zoneList && nextProps.zoneList.length && JSON.stringify(nextProps.zoneList) !== JSON.stringify(this.props.zoneList)) {
            this.setState({
                zoneList: [JSON.parse(JSON.stringify(nextProps.zoneList))]
            })
        }
    }

    onChange = (e, zone) => {
        const { isAdditionalZone } = this.props
        const { zoneList } = this.state;
        const { value, name } = e.target;
        const zIndex = ( zoneList || []).findIndex(zlist => (isAdditionalZone && zlist.additionalZoneTo || zlist.zone_to) === zone);
        const isValidInput = /^\+?\d*\.?\d*$/.test(value);
        if(zIndex >= 0) {
            zoneList[zIndex][name] = value && isValidInput && value || ''
        } else {
            zoneList.push({
                [name]: value && isValidInput && value || ''
            })
        }
        this.setState({ zoneList }, () => {
            this.props.onChange(zoneList, this.props.id);
        });
    }   

    acceptClicked = (e, trip) => {
        const { isAdditionalZone } = this.props;
        const acceptOrRejectLoiList = [ ...this.props.acceptOrRejectLoiList];
        if(e.target.checked) {
            acceptOrRejectLoiList.push({
                trip_id: trip[isAdditionalZone && 'id' || 'trip_id'],
                is_loi_with_cp_sent: trip.is_loi_with_cp_sent,
                challenge_price: trip.challenge_price
            })
        } else {
            const selIndex = acceptOrRejectLoiList.findIndex(aRlist => aRlist[isAdditionalZone && 'id' || 'trip_id'] === trip[isAdditionalZone && 'id' || 'trip_id']);
            if(selIndex >= 0) {
                acceptOrRejectLoiList.splice(selIndex, 1)
            }
        }
        this.props.saveListOfObjects(acceptOrRejectLoiList, this.props.acceptOrRejectCPList);
    }

    acceptCPClicked = (e,trip) => {
        const { isAdditionalZone } = this.props;
        const acceptOrRejectCPList = [ ...this.props.acceptOrRejectCPList];
        if(e.target.checked) {
            acceptOrRejectCPList.push({
                rfq_id: this.props.rfqId,
                trip_id: trip[isAdditionalZone && 'id' || 'trip_id'],
                price: trip.challenge_price,
                type: 0,
                tat: trip.tat,
            })
        } else {
            const selIndex = acceptOrRejectCPList.findIndex(aRlist => aRlist[isAdditionalZone && 'id' || 'trip_id'] === trip[isAdditionalZone && 'id' || 'trip_id']);
            if(selIndex >= 0) {
                acceptOrRejectCPList.splice(selIndex, 1)
            }
        }
        this.props.saveListOfObjects(this.props.acceptOrRejectLoiList, acceptOrRejectCPList);
    }

    hideAcceptPopup = () => {
        this.setState({
            isLoiAcceptPopupShown: false,
            isLoiRejectPopupShown: false,
            selectTrip: ''
        })
    }

    hideRejectPopup = () => {
        this.setState({
            isLoiAcceptPopupShown: false,
            isLoiRejectPopupShown: false,
            selectTrip: ''
        })
    }

    showAcceptPopup = (trip) => {
        const { isAdditionalZone } = this.props;
        const selectTrip = [{
            trip_id: trip[isAdditionalZone && 'id' || 'trip_id'],
            is_loi_with_cp_sent: trip.is_loi_with_cp_sent,
            challenge_price: trip.challenge_price
        }]
        this.setState({
            selectTrip,
            isLoiAcceptPopupShown: true
        })
    }

    showRejectPopup = (trip) => {
        const { isAdditionalZone } = this.props;
        const selectTrip = [{
            trip_id: trip[isAdditionalZone && 'id' || 'trip_id'],
            is_loi_with_cp_sent: trip.is_loi_with_cp_sent,
            challenge_price: trip.challenge_price
        }]
        this.setState({
            selectTrip,
            isLoiRejectPopupShown: true
        })
    }

    acceptLoi = () => {
        const { selectTrip } = this.state;
        this.props.postBidAll(2, selectTrip);
        this.hideAcceptPopup();
    }

    rejectLoi = () => {
        const { selectTrip } = this.state;
        this.props.postBidAll(3, selectTrip);
        this.hideRejectPopup();
    }

    handleChallengePrice = (type, item) => {
        const { isAdditionalZone } = this.props;
        if (type === 'accept') {
            this.props.postChallengePrice(item[isAdditionalZone && 'id' || 'trip_id'], {
                price: item.challenge_price,
                type: 0,
                tat: item.tat
            });
            this.props.acceptRejectCP(item[isAdditionalZone && 'id' || 'trip_id'], true);
        } else {
         this.props.acceptRejectCP(item[isAdditionalZone && 'id' || 'trip_id'], false);
      }
    }

    render() {
        const { zoneList } = this.state;
        const { biddingStage, systemTime, acceptOrRejectLoiList, isRilCPForm, acceptOrRejectCPList, tripBids, fetchBids, isAdditionalZone, lineItemSave, isCourierTermAccepted} = this.props;

        return (
            <Fragment>
            {(this.props.courierZones || []).map(zone => {
                const zoneData = zoneList.find(zlist => (isAdditionalZone && zlist.additionalZoneTo || zlist.zone_to) === zone.zone_to) || {
                    zone_to: zone.zone_to
                };
                let propsData = {};
                if(biddingStage['inProgress']) {
                    propsData = (this.props.zoneList).find(zne => zne[isAdditionalZone && 'id' || 'trip_id'] === zoneData[isAdditionalZone && 'id' || 'trip_id']);
                }
                return (
                    // <td style={{ "borderBottom": "1px solid grey"}}>
                    //     <table height={biddingStage['complete'] ? "100" : "auto"} cellpadding="0" cellspacing="0">
                    //     <tr>
                    <Fragment>
                            <td className="text-data orange-color fBold" width="75">
                                {isAdditionalZone && zoneData.additionalMaxQBR || zoneData.qbr}
                            </td>
                            <td className="text-data orange-color fBold" width="75">
                                {isAdditionalZone && zoneData.additionalMaxTAT || zoneData.max_tat }
                            </td>
                            <td className="text-data fBold" width="75">
                                {biddingStage['complete'] ? zoneData.price :
                                <Input className="wt-70 fBold" readOnly={!isCourierTermAccepted} value={zoneData.price || ''} name="price" onChange={(e) => this.onChange(e, (isAdditionalZone && zoneData.additionalZoneTo || zone.zone_to))}/>
                                }
                            </td>
                            <td className="text-data fBold" width="75">
                                {
                                biddingStage['complete'] ? zoneData.tat :
                                <div className="flex">
                                        <Input className="wt-50 fBold inBlock" readOnly={!isCourierTermAccepted} value={zoneData.tat || ''} name="tat" onChange={(e) => this.onChange(e, (isAdditionalZone && zoneData.additionalZoneTo ||zone.zone_to))}/>
                                    {isCourierTermAccepted && zoneData.price && zoneData.tat && ((propsData.price !== zoneData.price) || (propsData.tat !== zoneData.tat)) &&
                                        <SaveIcon className="wt-15 ht-15 curP tCenter mt-5 inBlock" onClick={() => this.props.onSaveEachBidPrice(zoneData, isAdditionalZone)} />
                                    }
                                </div>}
                            </td>
                            {(biddingStage['inProgress'] ||  biddingStage['complete']) && <td className="text-data pr">
                                    {/* {biddingStage['inProgress'] &&  */}
                                    <div className={'fBold mb-5 flex-middle mt-5'}>
                                        <div className="inBlock wt-25">
                                        <Status 
                                            status={zoneData.status && {
                                                statusText: zoneData.status.status_text,
                                                colorCode: zoneData.status.color_code
                                            } || {}}
                                            hideText={true}
                                        />
                                        </div>
                                        {zoneData.weighted_average && <div className={'orange-color inBlock fs-16 wt-30'}>({zoneData.weighted_average})</div>}
                                        {zoneData.status && <div className="inBlock ml-20">
                                            <SEOIcon className="curP fBold fs-18 wt-20 ht-20" onClick={(e) => { e.stopPropagation(); this.setState({ currentIndex:  zoneData[isAdditionalZone && 'id' || 'trip_id'], openPopup: true }) }}></SEOIcon>
                                            {
                                                this.state.currentIndex === zoneData[isAdditionalZone && 'id' || 'trip_id'] && this.state.openPopup && <OutsideClickHandler
                                                    onOutsideClick={() => {
                                                        this.setState({ currentIndex: '', openPopup: false })
                                                    }}>
                                                    <PostBidPopup
                                                        biddingDetails={{ price: zoneData.price, tatValue: zoneData.tat, tatUnit: '' }}
                                                        tripBids={tripBids}
                                                        fetchBids={fetchBids}
                                                        tripId={zoneData[isAdditionalZone && 'id' || 'trip_id']}
                                                    />
                                                </OutsideClickHandler>
                                            }
                                        </div>}
                                    </div> 
                                    
                                    {
                                        isRilCPForm &&
                                        <div className=" flex-1 fs-14 lh-15p pr fBold pl-5 pr-5 mb-5 wt-165"> 
                                            {
                                                zoneData.challenge_price &&
                                                <Fragment>
                                                {zoneData.cp_state === CHALLENGE_PRICE_SENT && zoneData.is_accept !== true && <input type="checkbox" name="acceptorrejectcp" checked={acceptOrRejectCPList && acceptOrRejectCPList.find((cp) => cp[isAdditionalZone && 'id' || 'trip_id'] === zoneData[isAdditionalZone && 'id' || 'trip_id'])} onClick={(e) => { e.stopPropagation(); this.acceptCPClicked(e, zoneData) }} />}
                                                <span className={'section-header-color'}>CP : </span>
												 <span className={zoneData.cp_state === 3 ? "error-color" :"challenge-color"}>{formatToINR(zoneData.challenge_price) || ''}</span>
                                                </Fragment>
                                            }
                                            {
                                                formatToINR(zoneData.price) && zoneData.price !== 0 &&
                                                zoneData.challenge_price < zoneData.price &&
                                                zoneData.challenge_price !== undefined &&
                                                zoneData.cp_state === CHALLENGE_PRICE_SENT &&
                                                zoneData.is_accept !== true && zoneData.is_loi_with_cp_sent !== true &&

                                                <React.Fragment>
                                                    <AcceptIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={() => this.handleChallengePrice('accept', zoneData)} />
                                                    <RejectIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={() => this.handleChallengePrice('reject', zoneData)} />
                                                </React.Fragment>
                                            }
                                        </div>
                                    }

                                    {zoneData.is_loi_sent && !zoneData.is_accept && zoneData.loi_accept_valid_to < systemTime && <div className="error-color fs-14 fBold mb-5">LOI Ignored</div>}
                                    {zoneData.is_loi_sent && zoneData.is_accept === true && <div className="challenge-color fs-14 fBold mb-5">LOI Accepted</div>}
                                    {!zoneData.is_loi_sent && zoneData.is_accept === false && <div className="error-color fs-14 fBold mb-5">LOI Rejected</div>}

                                    {zoneData.is_loi_sent && !zoneData.is_accept && zoneData.loi_accept_valid_from && zoneData.loi_accept_valid_to &&
                                        zoneData.loi_accept_valid_to >= systemTime &&
                                        <Fragment>
                                            <div className="flex flex-between flex-middle wt-165">
                                                <input type="checkbox" name="acceptorrejectlois" className="" checked={acceptOrRejectLoiList && acceptOrRejectLoiList.find((loi) => loi[isAdditionalZone && 'id' || 'trip_id'] === zoneData[isAdditionalZone && 'id' || 'trip_id'])} onClick={(e) => { e.stopPropagation(); this.acceptClicked(e, zoneData) }} />
                                                <span className="fSemibold pr-5 fs-14">LOI : </span>
                                                <span className="challenge-color curP pr-5 curP fBold fs-14" 
                                                onClick={(e) => { e.stopPropagation(); this.showAcceptPopup(zoneData) }}>
                                                    Accept
                                                    </span>
                                                <span className="pr-5 curP"> / </span>
                                                <span className="pr-5 error-color curP fBold fs-14" onClick={(e) => { e.stopPropagation(); this.showRejectPopup(zoneData) }}>Reject</span><br />
                                            </div>
                                            {
                                            zoneData.loi_accept_valid_from && zoneData.loi_accept_valid_to &&
                                            zoneData.loi_accept_valid_to >= systemTime &&
                                                <div className="zone-loi-timer">
                                                <Timer from={zoneData.loi_accept_valid_from} to={zoneData.loi_accept_valid_to} currentTime={systemTime} />
                                                </div>
                                            
                                            }
                                        {/* </div> */}
                                        </Fragment>
                                        }
        
                                </td>}
                                </Fragment>
                        // </tr>
                        // </table>
                    // </td>
                )
            })}
            {this.state.isLoiAcceptPopupShown && <ConfirmationPopup text={'Are You Sure You Want To Accept LOI?'} onConfirm={this.acceptLoi} onCancel={this.hideAcceptPopup} />}
			{this.state.isLoiRejectPopupShown && <ConfirmationPopup text={'Are You Sure You Want To Reject LOI?'} onConfirm={this.rejectLoi} onCancel={this.hideRejectPopup} />}
            </Fragment>
        )
    }
}